import type { IAccountEvent } from "@apis/accounts/types"
import { EventItem } from "./EventItem"
import type { IBaseEvent } from "@commonTypes/events"

type TEventListProps = {
  events: IAccountEvent[] | IBaseEvent[]
}

export const EventList = ({ events }: TEventListProps) => {
  if (!events.length) {
    return (
      <div className="tw:p-4 tw:text-center tw:text-gray-500">
        No events to display
      </div>
    )
  }
  return (
    <div className="tw:divide-y tw:divide-gray-200">
      {events.map((evt, i) => (
        <EventItem key={`${evt.type}-${evt.date}-${i}`} event={evt} />
      ))}
    </div>
  )
}
